module.exports = __webpack_public_path__ + "static/media/home-built-for-teachers.558b1e46.png";